/*
 * @Author: Damon
 * @Date: 2020-09-21 10:58:33
 * @LastEditors: damon
 * @LastEditTime: 2022-06-28 18:27:06
 * @Description: file content
 */
import axios from 'axios';
import {
  getAccessToken, removeAccessToken, removeUserInfo,
} from '@/utils/auth';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 1500000,
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    if (getAccessToken()) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${getAccessToken()}`;
    }
    return config;
  },
  error => Promise.reject(error),
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    return res;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        removeAccessToken();
        removeUserInfo();
        const url = `${window.location.protocol}//${window.location.host}/login`;
        // eslint-disable-next-line no-nested-ternary
        // const hrefUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' :
        // (process.env.NODE_ENV === 'staging' ? 'https://preadmin.vorwerkchina.com/login' : url);
        const hrefUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : url;

        window.location.href = hrefUrl;
      }
    }
    Promise.reject(error);
  },
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js